import { conversionFactors } from "../graphView/conversionFactors";

/**
 * Fish rows for binning (same shape as graph extractors): length in selectedUnit, status, stocking.
 */
export function buildFishRowsForBinsFromDetail(detail, selectedFish, selectedUnit) {
  const rows = [];
  const pondLengthUnit = detail.LengthUnitName?.toLowerCase() || "inch";
  const lengthConversion =
    conversionFactors.length[pondLengthUnit][selectedUnit.value];
  const sampling = detail.SamplingData || [];
  sampling.forEach((fish) => {
    if (
      selectedFish.length > 0 &&
      !selectedFish.some((f) => f.label === fish.FishTypeName)
    ) {
      return;
    }
    const originalLength = parseFloat(fish.Length || 0);
    const convertedLength = originalLength * lengthConversion;
    const status = fish.Status || fish.status || fish.FishStatus || "Unknown";
    const st = String(status).toLowerCase();
    rows.push({
      length: convertedLength,
      relativeWeight: parseFloat(fish.Wr || 0),
      species: fish.FishTypeName || "Unknown",
      status,
      isStocking: st === "stocking",
    });
  });
  return rows;
}
